import Skill from './skill'

export default Skill
